<template lang="pug">
  .challenge-builder-define-form
    .container.preventative-care-container(v-if="isPreventativeChallenge")
      WtTile(parent)
        WtTile(child child-class="")
          .columns.is-flex-wrap-wrap
            WtTile(parent).column.is-full.is-one-third-widescreen
              WtTile(child v-bind:style="{ 'background-image': 'url(' + challengeImage + ')' }").challenge-image
                WtTitle(card-title-large).challenge-image-name-container {{challengeName}}
            WtTile(parent).column.is-full.is-two-thirds-widescreen
              WtTile(child).is-gray-container
                UniquenessCheck(
                  label="Challenge Name"
                  entity="challengeName"
                  placeholder="My Awesome Challenge"
                  v-model="challengeName"
                  :readonly="previewMode"
                  @validName="setValidName($event)"
                  triggerUniquenessCheckOnMount
                )
                ChallengeDates(
                  :key="formData.mapId.value"
                  :is-challenge-builder-preview="previewMode"
                  :featured="Boolean(featured)"
                  @durationInputEvent="durationInputEvent"
                  @startDateInputEvent="startDateInputEvent"
                  @endDateInputEvent="endDateInputEvent"
                )
                WtRadioQuestionInput.block.mt-2(
                  label="Between"
                  :preview-mode="previewMode"
                  :preview-value="betweenText"
                  :labelTooltip="!isTeamLeader && !isAdmin ? 'Only Team Leaders can create team challenges' : null"
                )
                  template(v-slot:radioOne)
                    BRadio.define-radio(
                      v-model="between"
                      native-value="individuals"
                      :disabled="!isTeamLeader && !isAdmin"
                    )
                      | Individuals
                .column
                  .columns.is-multiline
                    .column.p-0.is-4
                      WtRadioQuestionInput(
                        label="Display custom title"
                        :preview-mode="previewMode"
                        :preview-value="useRecognitionTitlePreviewText"
                        :labelTooltip="!isTeamLeader && !isAdmin ? 'Only Team Leaders can create team challenges' : null"
                      )
                        template(v-slot:radioOne)
                          BRadio.define-radio(
                            v-model="useCustomRecognitionWallTitle"
                            :native-value="1"
                            :disabled="!isAdmin"
                          )
                            | Yes 
                          BRadio.define-radio(
                            v-model="useCustomRecognitionWallTitle"
                            :native-value="0"
                            :disabled="!isAdmin"
                          )
                            | No
                    .column.p-0
                      BField(
                        label="Recognition wall title"
                        :type="typeClass('recognition wall title')"
                        :message="recognitionWallTitleMessage"
                      )
                        BField.is-marginless(:type="typeClass('recognition wall title')")
                          BInput(
                            type="text"
                            v-model="customRecognitionWallTitle"
                            :readonly="previewMode && !editCustomRecognitionWallTitle"
                            :disabled="!useCustomRecognitionWallTitle"
                            name="recognition wall title"
                            :class="['is-expanded']"
                            v-validate="'required|min:1|max:100'"
                          )
                          WtReadonlyInputControls(
                            v-if="previewMode"
                            :edit="editCustomRecognitionWallTitle"
                            @editActive="$event => editCustomRecognitionWallTitle = $event"
                            @update="editCustomRecognitionWallTitle = false"
                          )
      WtTile(parent)
        WtTile(child child-class="")
          .columns
            WtTile(parent).column.is-full
              WtTile(child).is-gray-container
                .columns.is-flex-wrap-wrap
                  .column.is-full.is-half-widescreen
                    WtRadioQuestionInput.block(
                      label="Feature this challenge?"
                      :preview-mode="previewMode"
                      :preview-value="featured ? 'Yes' : 'No'"
                      horizontal
                    )
                      template(v-slot:radioOne)
                        BRadio.define-radio(
                          v-model="featured"
                          :native-value="1"
                        )
                          | Yes
                      template(v-slot:radioTwo)
                        BRadio.define-radio(
                          v-model="featured"
                          :native-value="0"
                        )
                          | No
                    .has-text-grey.m-2.mb-4.is-size-6 {{featuredChallengeText}}
                  .column.is-full.is-half-widescreen
                    BField
                      WtLabel(
                        slot="label"
                        text="Challenge Description"
                        label-for="atStake"
                      )
                      WtWysiwyg#atStake(
                        :key="activeStep"
                        selector="#atStake"
                        :content.sync="atStake"
                      )
                      WtReadonlyInputControls(
                        v-if="previewMode"
                        :edit="editAtStake"
                        @editActive="$event => editAtStake = $event"
                        @update="editAtStake = false"
                      )
      WtTile(parent)
        WtTile(child child-class="")
          .columns
            WtTile(parent).column.is-full
              WtTile(child).is-gray-container
                .columns.is-flex-wrap-wrap
                  .column.is-full.is-half-widescreen
                    BField
                      WtLabel(
                        slot="label"
                        text="Challenge Goal"
                      )
                    .has-text-grey.ml-0.my-4.is-size-6 {{challengeGoalText}}
                  .column.is-full.is-half-widescreen
                    BField(label="Completion date").normal-text-label
                    .is-flex.is-flex-direction-column
                      .is-flex
                        BCheckbox(
                          v-model="allowAddingCompletionDate"
                          :true-value="1"
                          :false-value="0"
                          disabled
                        )
                          | Allow users to add completion date
                    BField(label="Text input").normal-text-label.mt-5
                      .is-flex.is-flex-direction-column
                        .is-flex
                          BCheckbox(
                            v-model="allowFreeTextInput"
                            :true-value="1"
                            :false-value="0"
                          )
                            | Allow users to input free text
      WtTile(parent v-if="showIncentiveSettings")
        WtTile(child child-class="")
          .columns
            WtTile(parent).column.is-full
              WtTile(child).is-gray-container
                .columns.is-flex-wrap-wrap
                  .column.is-full.is-half-widescreen.p-0
                      WtTile(parent :col="12")
                        WtTile(child :col="12" child-class="")
                          WtSwitchQuestionInput.block(
                            label="Incentivize this challenge?"
                            :preview-mode="previewMode"
                            :preview-value="incentivizeChallenge"
                            v-model="incentivizeChallenge"
                          )
                      WtTile(parent :col="12")
                        WtTile(child :col="6" child-class="")
                          WtRadioQuestionInput.block(
                            label="Incentive Type"
                            :preview-mode="previewMode"
                            :preview-value="incentiveType"
                            :class="customRadioClass"
                          )
                            template(v-slot:radioOne)
                              BRadio.define-radio(
                                v-model="incentiveType"
                                native-value="award"
                                :disabled="!incentivizeChallenge"
                              ) Award set amount for all members who meet the challenge goal.
                        WtTile(child :col="1" child-class="")
                        WtTile(child :col="5" child-class="")
                          BField(
                            label="Incentive Amount"
                          )
                            BField.is-marginless
                              BInput(
                                :class="['is-expanded']"
                                v-model="incentiveAmount"
                                :readonly="previewMode && !editIncentiveAmount"
                                v-validate="'required'"
                                type="number"
                                :disabled="!incentivizeChallenge"
                              )
                              WtReadonlyInputControls(
                                v-if="previewMode"
                                :edit="editIncentiveAmount"
                                @editActive="$event => editIncentiveAmount = $event"
                                @update="editIncentiveAmount = false"
                              )
                          p {{incetiveAmountText }}
    .container(v-else)
      WtTile(parent)
        WtTile(child child-class="")
          .columns
            .column.is-three-quarters
              UniquenessCheck(
                label="Challenge Name"
                entity="challengeName"
                placeholder="My Awesome Challenge"
                v-model="challengeName"
                :readonly="previewMode"
                @validName="setValidName($event)"
                triggerUniquenessCheckOnMount
              )
            // STEP GOAL
            .column.is-one-quarter(v-show="showStepGoal")
              BField(
                label="Daily Step Goal"
                :type="typeClass('daily step goal')"
                :message="stepGoalMessage"
              )
                BField.is-marginless(:type="typeClass('daily step goal')")
                  BInput(
                    name="daily step goal"
                    :class="['is-expanded']"
                    placeholder=""
                    v-model="steps"
                    :readonly="previewMode && !editSteps"
                    v-validate="'required'"
                  )
                  WtReadonlyInputControls(
                    v-if="previewMode"
                    :edit="editSteps"
                    @editActive="$event => editSteps = $event"
                    @update="editSteps = false"
                  )
              BField(v-if="isAdminBuilder && (!previewMode || editSteps)")
                BCheckboxButton(
                  type="is-primary"
                  size="is-small"
                  v-model="useProgramGoal"
                  @input="setProgramGoal"
                  :native-value="true"
                ) {{ programGoalText }}

          ChallengeDates(
            :key="formData.mapId.value"
            :is-challenge-builder-preview="previewMode"
            :featured="Boolean(featured)"
            @durationInputEvent="durationInputEvent"
            @startDateInputEvent="startDateInputEvent"
            @endDateInputEvent="endDateInputEvent"
          )
      div(v-if="isWellnessChallenge")
        WtTile(parent)
          WtTile(child child-class="")
            WtTitle(h6 semibold) Challenge Description:
        WtTile(padding="small")
          WtTile(bordered)
            WtTile(parent)
              WtDisplayRichTextHTML(:html="chosenMap.description")
      // FORM - BOTTOM HALF
      WtTile.challenge-settings-title-container(parent)
        WtTile(child child-class="")
          WtTitle(h6 semibold) Challenge Settings:
      WtTile(padding="small")
        WtTile(bordered)
          // ============
          // WELLNESS
          // ============
          WtTile(parent :col="12" v-if="isWellnessChallenge")
            WtTile(child :col="3" v-if="isAdminBuilder && ($auth.user().isWtAdmin || $auth.user().isAdmin ) ")
              // FEATURED CHALLENGE
              // NOTE: allowing toggle here for testing
              // p.is-size-7.has-text-danger Only WT-admins can see the featured toggle for wellness challenges.
              WtSwitchQuestionInput.block(
                label="Is this a featured challenge?"
                :preview-mode="previewMode"
                :preview-value="featured"
                v-model="featured"
                :disabled="isWellnessChallenge && !$auth.user().isWtAdmin && !$auth.user().isAdmin"
              )
            template(v-if="isCustomWellnessChallenge")
              // Custom Wellness Challenge Settings
              WtTile(child :col="4" child-class="").pr-5
                BField(:message="totalPointsGoalPerDay")
                  WtLabel(
                    slot="label"
                    text="Points Goal Per Day"
                    :tooltip-text="pointsGoalTooltipText"
                    label-for="pointsGoalPerDay"
                  )
                  BInput(
                    v-model="pointsGoalPerDay"
                    :readonly="previewMode && !editPointsGoal"
                    type="number"
                    :min="1"
                  )
                    | {{ pointsGoalPerDay }}
                  WtReadonlyInputControls(
                    v-if="previewMode"
                    :edit="editPointsGoal"
                    @editActive="$event => editPointsGoal = $event"
                    @update="editPointsGoal = false"
                  )
              WtTile(child :col="8" child-class="")
                BField
                  WtLabel(
                    slot="label"
                    :text="`${customWellnessTotalPointsPossiblePerDay} Total Potential Challenge Points Per Day.`"
                    :tooltip-text="pointsTotalTooltipText"
                  )
                BField(
                  label="Points Breakdown"
                )
                  WellnessChallengePointsBreakDownDetails(
                    :metricsTracking="chosenMap.metricsTracking"
                    :isCustomWellness="Boolean(isCustomWellnessChallenge)"
                  )
            WtTile(child :col="3" padding="small" child-class="" v-if="!isCustomWellnessChallenge")
              // Allow Journal Entries and Questions Points (optional additional metrics)
              template(v-if="!isCustomWellnessChallenge")
                BField(label="Allow points for:")
                  .is-flex.is-flex-direction-column
                    .is-flex.mb-2
                      BCheckbox(
                        v-model="trackTextAndImagePoints"
                        :true-value="1"
                        :false-value="0"
                      )
                        | Journal Entries
                      BTooltip(
                        label="Participants can earn points for posting photos and journal entries. Adds 48 points to the challenge goal."
                        position="is-top"
                        animated
                        type="is-light"
                        multilined
                      )
                        BIcon(icon="help-circle-outline" size="is-small")
                    .is-flex.mb-2
                      BCheckbox(
                        v-model="trackQuestionPoints"
                        :true-value="1"
                        :false-value="0"
                      )
                        | Questions
                      BTooltip(
                        label="Participants can earn points for answering 3 automated challenge questions. Adds 60 points to the challenge goal. "
                        position="is-top"
                        animated
                        type="is-light"
                        multilined
                      )
                        BIcon(icon="help-circle-outline" size="is-small")
            WtTile(child :col="4" padding="small" child-class="" v-if="!isCustomWellnessChallenge")
              template(v-if="!isCustomWellnessChallenge")
                .is-flex.is-flex-direction-row
                  .is-flex.mr-1
                    BField(label="This challenge also allows points for:")
                  .is-flex
                    BTooltip(
                      label="These metrics will automatically earn points in this challenge. Adding Journal Entries and/or Questions is optional."
                      position="is-top"
                      animated
                      type="is-light"
                      multilined
                    )
                      BIcon(icon="help-circle-outline" size="is-small")
                .is-flex.mt-2
                  WellnessChallengePointsBreakDownDetails(
                    :metricsTracking="chosenMap.metricsTracking"
                  )
          // ============
          // NOT WELLNESS
          // ============
          WtTile(parent :col="12" v-if="!isWellnessChallenge")
            WtTile(child :col="5" child-class="")
              // DON'T SHOW FOR WELLNESS CHALLENGES
              template(v-if="!isWellnessChallenge")
                // FEATURED CHALLENGE
                WtSwitchQuestionInput.block(
                  v-if="isAdminBuilder"
                  label="Is this a featured challenge?"
                  tooltip-text="Toggle to YES if you’d like your members to receive milestone emails as they progress through this challenge"
                  :preview-mode="previewMode"
                  :preview-value="featured"
                  v-model="featured"
                  :disabled="isWellnessChallenge && !$auth.user().isWtAdmin"
                )
                // INVITE ONLY
                WtRadioQuestionInput.block(
                  v-if="!featured"
                  label="Who can see and join this challenge?"
                  :preview-mode="previewMode"
                  :preview-value="publicAndOpenText"
                )
                  template(v-slot:radioOne)
                    BRadio.define-radio(
                      v-model="publicAndOpen"
                      :native-value="1"
                    )
                      | All members
                  template(v-slot:radioTwo)
                    BRadio.define-radio(
                      v-model="publicAndOpen"
                      :native-value="0"
                    )
                      | Selected members only

                // BETWEEN
                WtRadioQuestionInput.block(
                  v-if="showTeamStuff"
                  label="Is this between Individuals or Teams?"
                  :preview-mode="previewMode"
                  :preview-value="betweenText"
                  :labelTooltip="!isTeamLeader && !isAdmin ? 'Only Team Leaders can create team challenges' : null"
                )
                  template(v-slot:radioOne)
                    BRadio.define-radio(
                      v-model="between"
                      native-value="individuals"
                      :disabled="!isTeamLeader && !isAdmin"
                    )
                      | Individuals
                  template(v-slot:radioTwo)
                    BRadio.define-radio(
                      v-model="between"
                      native-value="groups"
                      :disabled="!isTeamLeader && !isAdmin"
                    )
                      | Teams
              WtTile(child child-class="")
                // DON'T SHOW FOR WELLNESS CHALLENGES
                template(v-if="!isWellnessChallenge")
                  // TRACKING
                  WtRadioQuestionInput.tracking-options(
                    :label="coreProgramMeta.converter ? 'What To Track:' : 'What To Track (note, activity converter disabled sitewide):'"
                    :preview-value="trackingText"
                    :preview-mode="previewMode"
                  )
                    template(v-slot:radioOne)
                      BRadio.define-radio(
                        v-model="allowActivities"
                        :native-value="stepsValue"
                      )
                        | Steps
                    template(v-slot:radioTwo)
                      BRadio.define-radio(
                        v-model="allowActivities"
                        :native-value="activitiesValue"
                        :disabled="!coreProgramMeta.converter"
                      )
                        | Activities
                    template(v-slot:radioThree)
                      BRadio.define-radio(
                        v-model="allowActivities"
                        :native-value="stepsAndActivitiesValue"
                        :disabled="!coreProgramMeta.converter"
                      )
                        | Steps & Activities

                  // TRACKING CALCULATION
                  WtRadioQuestionInput.tracking-options(
                    v-if="isTeamChallenge"
                    :label="'How To Track:'"
                    :preview-value="trackingCalcText"
                    :preview-mode="previewMode"
                  )
                    template(v-slot:radioOne)
                      BRadio.define-radio(
                        v-model="trackingCalc"
                        :native-value="0"
                      )
                        | Average
                    template(v-slot:radioTwo)
                      BRadio.define-radio(
                        v-model="trackingCalc"
                        :native-value="1"
                      )
                        | Total

                  BField
                    WtLabel(
                      slot="label"
                      text="Challenge Description"
                      :tooltip-text="atStakeTooltip"
                      label-for="atStake"
                    )
                    WtWysiwyg#atStake(
                      :key="activeStep"
                      selector="#atStake"
                      :content.sync="atStake"
                    )
                    WtReadonlyInputControls(
                      v-if="previewMode"
                      :edit="editAtStake"
                      @editActive="$event => editAtStake = $event"
                      @update="editAtStake = false"
                    )

      WtTile.challenge-settings-title-container(parent v-if="showIncentiveSettings")
        WtTile(child child-class="")
          WtTitle(h6 semibold) Incentive Settings:
      WtTile(padding="large" v-if="showIncentiveSettings")
        WtTile(bordered padding="large" vertical)
          WtTile(parent :col="12")
            WtTile(child :col="12" child-class="")
              WtSwitchQuestionInput.block(
                label="Incentivize this challenge?"
                :preview-mode="previewMode"
                :preview-value="incentivizeChallenge"
                v-model="incentivizeChallenge"
              )
          WtTile(parent :col="12")
            WtTile(child :col="6" child-class="")
              WtRadioQuestionInput.block(
                label="Incentive Type"
                :preview-mode="previewMode"
                :preview-value="incentiveType"
                :class="customRadioClass"
              )
                template(v-slot:radioOne)
                  BRadio.define-radio(
                    v-model="incentiveType"
                    native-value="split"
                    :disabled="!incentivizeChallenge"
                  ) Split incentive equally among all members who meet the challenge goal.
                  br
                template(v-slot:radioTwo)
                  BRadio.define-radio(
                    v-model="incentiveType"
                    native-value="award"
                    :disabled="!incentivizeChallenge"
                  ) Award set amount for all members who meet the challenge goal.
            WtTile(child :col="1" child-class="")
            WtTile(child :col="5" child-class="")
              BField(
                label="Incentive Amount"
              )
                BField.is-marginless
                  BInput(
                    :class="['is-expanded']"
                    v-model="incentiveAmount"
                    :readonly="previewMode && !editIncentiveAmount"
                    v-validate="'required'"
                    type="number"
                    :disabled="!incentivizeChallenge"
                  )
                  WtReadonlyInputControls(
                    v-if="previewMode"
                    :edit="editIncentiveAmount"
                    @editActive="$event => editIncentiveAmount = $event"
                    @update="editIncentiveAmount = false"
                  )
              p {{incetiveAmountText }}
      WtTile.challenge-members-invited(parent padding="large" v-if="previewMode")
        WtTile(padding="large" v-if="memberMode")
          .has-text-info.level(v-if="formData.includeAll.value")
            .level-left
              .level-item
                BIcon(icon="account-group")
              .level-item
                span.has-text-weight-semibold &nbsp; All members of the program will be {{ formData.includeType.value === "invite" ? "invited" : "added"}}.
          MembersTable.members-table(mode="receiver" v-else)
        WtTile(padding="large" v-if="teamMode")
          .has-text-info.level(v-if="formData.includeAll.value")
            .level-left
              .level-item
                BIcon(icon="account-group")
              .level-item
                span.has-text-weight-semibold &nbsp; {{ challengeInfoText }} .
          TeamsTable.teams-table(mode="receiver" v-else)
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";
import formDataMixin from "@@/ChallengeBuilder/formDataMixin";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtLabel from "@@/WtLabel/WtLabel";
import WtWysiwyg from "@@/WtWysiwyg/WtWysiwyg";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";
import WtReadonlyInputControls from "@@/WtReadonlyInputControls/WtReadonlyInputControls";
import WtRadioQuestionInput from "@@/WtRadioQuestionInput/WtRadioQuestionInput";
import DatePickerFooter from "./ChallengeBuilderDatePickerFooter";
import MembersTable from "@@/Members/MembersTable";
import TeamsTable from "@@/ChallengeBuilder/ChallengeBuilderTeamsTable";
import ChallengeDates from "@@/ChallengeBuilder/ChallengeDates";
import WellnessChallengePointsBreakDownDetails from "@@/Challenge/WellnessChallenge/WellnessChallengePointsBreakDownDetails";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";

const STEPS = 0;
const ACTIVITIES = 2;
const STEPS_AND_ACTIVITIES = 1;

export default {
  name: "ChallengeBuilderDefineForm",

  components: {
    WtLabel,
    DatePickerFooter,
    UniquenessCheck,
    WtRadioQuestionInput,
    WtSwitchQuestionInput,
    WtReadonlyInputControls,
    WtTile,
    WtTitle,
    WtWysiwyg,
    MembersTable,
    TeamsTable,
    ChallengeDates,
    WellnessChallengePointsBreakDownDetails,
    WtDisplayRichTextHTML
  },

  mixins: [dateUtilityMixin, numberUtilityMixin, formDataMixin],

  props: {
    validate: {
      type: Boolean,
      default: false
    },

    /**
     * enables readonly input views which can
     * be toggled for final edits on Step 4
     */
    previewMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      stepsValue: STEPS,
      activitiesValue: ACTIVITIES,
      stepsAndActivitiesValue: STEPS_AND_ACTIVITIES,
      isNameValid: false,
      isCustomTitleValid: true,
      editSteps: false,
      editStartDate: false,
      editDuration: false,
      editAtStake: false,
      atStakeTooltip: `This description shows with the challenge. Edit or change it as necessary.`,
      useProgramGoal: false,
      editIncentiveAmount: false,
      editPointsGoal: false,
      pointsGoalTooltipText: `The points goal is usually a bit less that the total points possible given the points breakdown.`,
      pointsTotalTooltipText: `Does not include weekly points. For example, weight.`,
      editCustomRecognitionWallTitle: false,
      disableCustomRecognitionWallTitle: true
    };
  },

  computed: {
    ...mapGetters("challengeBuilder", [
      "formData",
      "memberMode",
      "teamMode",
      "pointsGoalPerDay",
      "activeStep",
      "stagedOrganizations"
    ]),
    ...mapGetters("program", [
      "coreProgramMeta",
      "isCoreTier",
      "activeChallenges",
      "activeChallengesLoaded",
      "isTeamsFeatureOn",
      "featuredChallenges",
      "featuredChallengesLoaded",
      "maps",
      "isIncentiveIntegrationOn",
      "programOrganizations"
    ]),
    ...mapGetters("authMember", ["isAdmin", "isTeamLeader"]),

    ...mapGetters("organizations", [
      "organizationTeams",
      "organizationsLoaded"
    ]),

    isAdminBuilder() {
      return /admin/.test(this.$route.path);
    },

    recognitionWallTitleMessage() {
      if (!this.isCustomTitleValid) {
        return "Recognition wall title is required";
      }
      return "";
    },

    showTeamStuff() {
      return this.isTeamsFeatureOn;
    },

    isWellnessChallenge() {
      let map = this.maps.find(
        map => map.id === this._.get(this.formData, "mapId.value", null)
      );
      return this._.get(map, "isWellnessChallenge", false);
    },

    isCustomWellnessChallenge() {
      let map = this.maps.find(
        map => map.id === this._.get(this.formData, "mapId.value", null)
      );
      return this._.get(map, "isCustomWellnessChallenge", false);
    },

    isPreventativeChallenge() {
      let map = this.maps.find(
        map => map.id === this._.get(this.formData, "mapId.value", null)
      );
      return this._.get(map, "isPreventativeChallenge", false);
    },

    selectedChallengeOrganizationName() {
      const organizationId = this.stagedOrganizations[0].id;
      const organization = this.programOrganizations.find(
        org => org.id === organizationId
      );
      const organizationName = organization ? organization.name : null;
      return organizationName;
    },

    chosenMap() {
      return this.maps.find(
        map => map.id === this._.get(this.formData, "mapId.value", null)
      );
    },

    betweenText() {
      return this.between === "groups" ? "Teams" : "Individuals";
    },

    useRecognitionTitlePreviewText() {
      return this.useCustomRecognitionWallTitle === 1 ? "Yes" : "No";
    },

    isTeamChallenge() {
      return this.between === "groups";
    },

    publicAndOpenText() {
      return this.publicAndOpen ? "All members" : "Selected members only";
    },

    trackingText() {
      let text = "Steps";

      if (this.allowActivities === 1) {
        text = "Steps & Activities";
      } else if (this.allowActivities === 2) {
        text = "Activities";
      }

      return text;
    },

    trackingCalcText() {
      return this.trackingCalc ? "Total" : "Average";
    },

    stepGoalMessage() {
      if (this.errors.first("daily step goal")) {
        return this.errors.first("daily step goal");
      }

      return "";
    },

    programGoalText() {
      if (this.useProgramGoal) {
        return "Using program step goal!";
      }
      return `Use Program Goal of ${this.formatWithCommas(
        this.coreProgramMeta.defaultStepGoal
      )} steps`;
    },

    showIncentiveSettings() {
      return this.$auth.user().isAdmin && this.isIncentiveIntegrationOn;
    },

    incetiveAmountText() {
      if (this.showIncentiveSettings) {
        switch (this.incentiveType) {
          case "split":
            return "This amount will be split equally among all challenge participants who meet the challenge goal.";
          case "award":
            return "This amount will be awarded to each challenge participant who meets the challenge goal.";
          default:
            return "";
        }
      }
      return "";
    },

    customRadioClass() {
      if (!this.previewMode) {
        return "flex-radio-input";
      }
      return "";
    },

    showStepGoal() {
      return (
        this.formData.isGoal.value &&
        !(this.isWellnessChallenge || this.isPreventativeChallenge)
      );
    },

    challengeImage() {
      return this.chosenMap.image;
    },

    featuredChallengeText() {
      return (
        "A featured challenge is your programs's main challenge.\n" +
        "Featured challenges are ranked higher in visibility than other challenges" +
        " in your program, and they are always public and open to join for all program members." +
        " Only one featured challenge can be scheduled at a time."
      );
    },

    challengeGoalText() {
      return "Everyone who meets the challenge goal at the end of a challenge is considered a winner.";
    },

    totalPointsGoalPerDay() {
      return "Total Points Goal: " + this.pointsGoal;
    },

    challengeInfoText() {
      let includeType =
        this.formData.includeType.value === "invite" ? "invited" : "added";
      let competitionOf = this.formData.competitionOf.value;
      if (competitionOf === "Organization") {
        let teamsCount = this.organizationTeams?.data?.length || 0;
        let organizationName = this.selectedChallengeOrganizationName;
        if (this.organizationsLoaded && !teamsCount) {
          return `${organizationName} organization currently doesn't have any teams, but you can add teams to the challenge at a later time`;
        } else {
          return `All teams in the ${organizationName} Organization will be ${includeType}`;
        }
      } else {
        return `All teams in the program will be ${includeType}`;
      }
    },

    customWellnessTotalPointsPossiblePerDay() {
      let metrics = { ...this.chosenMap.metricsTracking };
      // remove weight since it's per week
      delete metrics.weight;

      return Object.values(metrics).reduce((previousValue, currentValue) => {
        return previousValue + currentValue;
      }, 0);
    },

    pointsGoalPerDay: {
      get() {
        return this.$store.state.challengeBuilder.pointsGoalPerDay;
      },
      set(value) {
        this.$store.commit("challengeBuilder/SET_POINTS_GOAL_PER_DAY", value);
      }
    }
  },

  watch: {
    steps(steps) {
      if (steps > 0) {
        this.steps = this.formatWithCommas(steps);

        this.checkFormCompletion();
      }
    },

    startDate: {
      handler: function() {
        this.checkFormCompletion();
      },
      immediate: true
    },

    endDate: {
      handler: function() {
        this.checkFormCompletion();
      },
      immediate: true
    },

    duration: {
      handler: function() {
        this.pointsGoal = this.duration * this.pointsGoalPerDay;
        this.checkFormCompletion();
      },
      immediate: true
    },

    featured() {
      this.checkFormCompletion();
      if (this.featured) {
        this.publicAndOpen = 1;
      }
    },

    between: {
      handler: function(newValue) {
        let mode = newValue === "groups" ? "team" : "member";
        this.setModes(mode);
        this.updateFormData([{ key: "between", value: this.between }]);
      },
      immediate: true
    },

    incentivizeChallenge: {
      handler: function() {
        this.checkFormCompletion();
      },
      immediate: true
    },

    incentiveType: {
      handler: function() {
        this.checkFormCompletion();
      },
      immediate: true
    },

    customRecognitionWallTitle: {
      handler: function() {
        this.isCustomTitleValid =
          this.customRecognitionWallTitle.trim() !== "" ||
          !this.isPreventativeChallenge;
        this.checkFormCompletion();
      },
      immediate: false
    },

    incentiveAmount: {
      handler: function() {
        this.checkFormCompletion();
      },
      immediate: true
    },
    isPreventativeChallenge(value) {
      // default settings for preventative care challenge
      if (value) {
        this.setPreventativeCareChallengeSettings();
      }
    },
    pointsGoalPerDay: {
      handler: function() {
        this.pointsGoal = this.pointsGoalPerDay * this.duration;
      },
      immediate: true
    }
  },

  async created() {
    if (!this.activeChallengesLoaded) {
      this.fetchActiveChallenges({ programId: this.$auth.user().programId });
    }
    //TODO fetchFeaturedChallenge now returns all featured challenges - rename to fetchFeaturedChallenges
    if (!this.featuredChallengesLoaded) {
      await this.fetchFeaturedChallenge(this.$auth.user().programId);
    }

    // assume if we're in the preview-mode that the ChallengeName was validated previously during the define step
    if (this.previewMode) {
      this.isNameValid = true;
    }
    if (this.previewMode) {
      this.isCustomTitleValid = true;
    }
    // validate because the ChallengeBuilderReview needs to trigger validationResult
    this.checkFormCompletion();
  },

  mounted() {
    // on initial load feature is set based on admin status, when Review loads feature is set based on the toggle value
    if (!this.previewMode) {
      this.featured = this.$auth.user().isAdmin ? 1 : 0;
    }
    // assign atStake to be chosenMap's description
    if (!this.previewMode) {
      this.atStake = this._.get(this.chosenMap, "description", "");
    }

    if (this.isPreventativeChallenge) {
      this.setPreventativeCareChallengeSettings();
    }
  },

  methods: {
    ...mapActions("challengeBuilder", ["updateFormData", "setModes"]),
    ...mapActions("program", [
      "fetchActiveChallenges",
      "fetchFeaturedChallenge"
    ]),

    setValidName(value) {
      this.isNameValid = value;
      this.checkFormCompletion();
    },

    typeClass(fieldName) {
      let className = "";

      if (this.errors.has(fieldName)) {
        className = "is-danger";
      }

      return className;
    },

    checkFormCompletion() {
      let valuesToConsider = [this.duration, this.startDate, this.endDate];
      if (!(this.isWellnessChallenge || this.isPreventativeChallenge))
        valuesToConsider.push(this.steps);
      if (this.incentivizeChallenge)
        valuesToConsider.push(this.incentiveType, this.incentiveAmount);

      if (
        valuesToConsider.some(val => !val) ||
        !this.isNameValid ||
        !this.isCustomTitleValid
      ) {
        this.$emit("validationResult", false);
      } else {
        this.$emit("validationResult", true);
      }
    },

    setProgramGoal(value) {
      if (value) {
        return (this.steps = this.coreProgramMeta.defaultStepGoal);
      }
      return (this.steps = "");
    },

    durationInputEvent($event) {
      this.duration = $event;
    },

    startDateInputEvent($event) {
      this.startDate = $event;
    },

    endDateInputEvent($event) {
      this.endDate = $event;
    },

    setPreventativeCareChallengeSettings() {
      if (!this.previewMode) {
        this.updateFormData([
          {
            key: "between",
            value: "individuals"
          },
          {
            key: "allowAddingCompletionDate",
            value: 1
          },
          {
            key: "customRecognitionWallTitle",
            value: this.challengeName
          },
          {
            key: "useCustomRecognitionWallTitle",
            value: 1
          }
        ]);
      }
    }
  }
};
</script>

<style lang="sass">
.challenge-builder-define-form
  .flex-radio-input .field.has-addons
    flex-direction: column
  .radio-question-input-column
    margin-bottom: 0

  .challenge-settings-title-container
    padding-bottom: 0 !important

  .start-date-column,
  .end-date-column,
  .duration-column
    padding-top: 0 !important
    padding-bottom: 25px !important
    input[disabled]
      color: $grey-darker !important

  .challenge-members-invited
    .members-table
      width: 100%
  .tracking-options
    .field.has-addons
      @media screen and (max-width: 480px)
        flex-direction: column
      .b-radio.radio
        @media screen and (max-width: 480px)
          margin-top: 0.5rem
  .is-gray-container
    background-color: $grey-lighter
  .challenge-image
    background-size: cover
    background-repeat: no-repeat
    min-height: 300px
    -webkit-box-shadow: inset 20px -20px 40px 10px #000000 !important
    box-shadow: inset 20px -20px 40px 10px #000000 !important
  .challenge-image-name-container
    color: white
    position: absolute
    left: 20px
    bottom: 20px
  .preventative-care-container .label
    font-family: $family-sans-serif-bold
  .preventative-care-container .normal-text-label .label
    font-family: $family-sans-serif
  .preventative-care-container
    .b-checkbox.checkbox input[type=checkbox] + .check
      border-radius: 5px !important
  .preventative-incentive-type-custom-radio .field-body .has-addons
      flex-direction: row
</style>
